(() => {
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealObserver = 'IntersectionObserver' in window && !motionPreference.matches
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }) : null;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mbm-disclosure]').forEach((details) => {
      if (details.dataset.mbmInitialized) return;
      details.dataset.mbmInitialized = 'true';
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (!details.open) return;
        document.querySelectorAll('[data-mbm-disclosure]').forEach((other) => {
          if (other !== details) other.open = false;
        });
        const search = details.querySelector('input[type="search"]');
        if (search) search.focus();
      });
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        details.open = false;
        summary.focus();
      });
    });
  };
  const initializePersonalize = (scope = document) => {
    scope.querySelectorAll('[data-mbm-personalize]').forEach((section) => {
      if (section.dataset.mbmInitialized) return;
      section.dataset.mbmInitialized = 'true';
      const buttons = [...section.querySelectorAll('[data-mbm-step]')];
      const preview = section.querySelector('[data-mbm-preview]');
      const scenes = [...section.querySelectorAll('[data-mbm-scene]')];
      const caption = section.querySelector('[data-mbm-caption-output]');
      const counter = section.querySelector('[data-mbm-counter]');
      const progress = [...section.querySelectorAll('.mbm-personalize__progress span')];
      const select = (button) => {
        const index = buttons.indexOf(button);
        buttons.forEach((other) => {
          const active = other === button;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', String(active));
        });
        scenes.forEach((scene) => { scene.hidden = Number(scene.dataset.mbmScene) !== index; });
        preview.dataset.step = String(index);
        caption.textContent = button.dataset.mbmCaption;
        counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(buttons.length).padStart(2, '0')}`;
        progress.forEach((segment, i) => segment.classList.toggle('is-active', i <= index));
      };
      const options = [...section.querySelectorAll('[data-mbm-option]')];
      const optionImage = section.querySelector('[data-mbm-option-image]');
      options.forEach((option) => option.addEventListener('click', () => {
        if (!optionImage || option.getAttribute('aria-pressed') === 'true') return;
        optionImage.src = option.dataset.mbmSrc;
        optionImage.alt = option.dataset.mbmAlt;
        options.forEach((other) => other.setAttribute('aria-pressed', String(other === option)));
        if (!motionPreference.matches && typeof optionImage.animate === 'function') {
          optionImage.animate([{ opacity: .5 }, { opacity: 1 }], { duration: 250 });
        }
      }));
      buttons.forEach((button) => button.addEventListener('click', () => select(button)));
      section.addEventListener('keydown', (event) => {
        const index = buttons.indexOf(event.target);
        if (index < 0 || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus();
        select(buttons[next]);
      });
      section.addEventListener('shopify:block:select', (event) => {
        const button = event.target.closest('[data-mbm-step]');
        if (button && buttons.includes(button)) select(button);
      });
    });
    if (revealObserver) scope.querySelectorAll('.mbm-section-heading, .mbm-category, .mbm-product, .mbm-story__panel, .mbm-personalize__grid, .mbm-faq__grid').forEach((element) => {
      if (element.classList.contains('mbm-reveal')) return;
      element.classList.add('mbm-reveal');
      revealObserver.observe(element);
    });
  };
  initialize();
  initializePersonalize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:load', (event) => initializePersonalize(event.target));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-mbm-disclosure][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
